/**
 * The only two localStorage keys allowed by spec §2: `lang` and
 * `lastOptions`. Every access is wrapped in try/catch so the app keeps
 * working with storage disabled (private browsing, blocked site data, etc.).
 */
export type StorageKey = "lang" | "lastOptions";

export function readStorage(key: StorageKey): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(key: StorageKey, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Ignored on purpose: the game must keep working without storage.
  }
}

export function readJsonStorage<T>(key: StorageKey): T | null {
  const raw = readStorage(key);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function writeJsonStorage<T>(key: StorageKey, value: T): void {
  try {
    writeStorage(key, JSON.stringify(value));
  } catch {
    // Ignored on purpose.
  }
}
